import { isCanceledRequest } from 'components/perimeter/perimeterErrors';
import { useCallback, useRef } from 'react';

/**
 * Lets a page read again while an older read is still running: `latest(promise)`
 * settles like `promise` only if no read started after it, and never for a
 * cancelled request. The record pages cancel their own older read (their
 * requests share abort keys), which must not show as an error.
 */
const useLatestCall = () => {
  const count = useRef(0);
  return useCallback((promise) => {
    count.current += 1;
    const mine = count.current;
    return new Promise((resolve, reject) => {
      promise.then(
        (value) => mine === count.current && resolve(value),
        (error) => mine === count.current && !isCanceledRequest(error) && reject(error),
      );
    });
  }, []);
};

export default useLatestCall;
